import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/unidentified.png'


const _hoisted_1 = { class: "bg-primary text-white" }
const _hoisted_2 = { class: "hf-container flex column justify-between full-height" }
const _hoisted_3 = { class: "toolbar-nav flex justify-between items-center" }
const _hoisted_4 = { class: "toolbar-nav-left" }
const _hoisted_5 = { class: "flex row justify-between content-center" }
const _hoisted_6 = { class: "navbar-tabs" }
const _hoisted_7 = { class: "row items-center" }
const _hoisted_8 = { class: "toolbar-nav-right" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "header-username ellipsis"
}
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "bg-grey-4 text-primary"
}
const _hoisted_14 = {
  key: 1,
  class: "bg-grey-4 text-primary"
}
const _hoisted_15 = { class: "bg-grey-4 text-primary" }
const _hoisted_16 = { class: "row items-center justify-center text-white" }
const _hoisted_17 = {
  key: 0,
  class: "q-pr-xl"
}
const _hoisted_18 = { class: "text-h6 q-pl-sm" }
const _hoisted_19 = {
  key: 0,
  class: "img-fluid rounded-borders"
}
const _hoisted_20 = {
  key: 1,
  src: _imports_0,
  class: "img-fluid rounded-borders"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 0,
  class: "q-pa-md text-center"
}
const _hoisted_23 = { class: "text-h6" }
const _hoisted_24 = { class: "text-h7" }
const _hoisted_25 = { class: "text-h6" }
const _hoisted_26 = { class: "q-pa-md" }
const _hoisted_27 = { class: "row full-width justify-end q-pa-md" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "fit row justify-end" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "fit row justify-end q-pr-sm" }
const _hoisted_32 = { class: "text-h6" }

import { ref, onMounted as vueOnMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { useI18n } from 'vue-i18n';

import BrandFooter from '@/components/BrandFooter.vue';
import TenantInfo from '@/components/TenantInfo.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import {
  Tenant,
  User,
  LoginRequest,
  ChangePasswordRequest,
  NotificationMessage,
  ChatMessageRequest,
  ChatMessage,
  TenantMessageInfo,
  ILabelValue,
  CountriesOptionResponse,
  AllChatMessageRequestDto,
  WipeOutAuthCredentialsDto
} from '../store/models';
import tenantModule from '@/store/modules/tenantModule';
import userModule from '@/store/modules/userModule';
import { showSuccessMsgToast, showErrorMsgToast } from '@/common';
import ServerNotification from '@/components/ServerNotification.vue';
import chatMessageModule from '@/store/modules/chatMessageModule';
import CreateNewTenantComp from '@/components/CreateNewTenantComp.vue';
import notificationSound from '@/assets/message_notification.mp3';
import jobAdministrationModule from '@/store/modules/jobAdministrationModule';
import findIndex from 'lodash-es/findIndex';
import TagsManagement from '../components/TagsManagement.vue';

const name = 'MainLayout';

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const $q = useQuasar();
const { t, locale } = useI18n();

// Define reactive variables
const onMounted = vueOnMounted;
const tenant = ref<Tenant | null>(null);
const toolbarValue = ref<string>('');
const isShowChPwDialog = ref<boolean>(false);
const newPassword = ref<string>('');
const isHidePassword = ref<boolean>(true);
const currentUser = ref<string>('');
const showMessageDialog = ref<boolean>(false);
const messages = ref<ChatMessage[]>([]);
const tenantMessageInfo = ref<TenantMessageInfo | undefined>(undefined);
const renderMessageBtn = ref<boolean>(false);
const unreadMessages = ref<number>(0);

const showMasterDataTab = ref<boolean | null>(false);
const showSettingsTab = ref<boolean | null>(false);
const showCreateTenantTab = ref<boolean | null>(false);
const showMessagesLoadingSpinner = ref<boolean>(true);

const currentCreateTenantWizardStep = ref<string>('1');
const messageCenterStandalone = ref<boolean>(false);
const showDefaultHeaderMenu = ref<boolean>(false);
const showMessageCenterMenu = ref<boolean>(false);
const messageCenterFeature = ref<boolean>(false);
const messageCenterCred = ref<boolean | null>(false);
const superAdminCred = ref<boolean | null>(false);
const showNavigationDropdown = ref<boolean>(false);
const selectedTopLevelNav = ref<string>('pitchyou');
const showPreferredLanguageDialog = ref<boolean>(false);
const languageOptions = ref<ILabelValue[]>([]);
const languageOptionsResponse = ref<CountriesOptionResponse | null>(null);

const preferredLanguage = ref<ILabelValue | null>(null);
const showLoadingIndicator = ref<boolean>(false);
const currentPageNumber = ref<number>(0);
const totalPages = ref<number>(0);
const pageLimit = ref<number>(50);
const nextPageNumber = ref<number>(0);
const bulkMessageCred = ref<boolean | null>(false);
const assessmentCred = ref<boolean | null>(false);
const showTagsManagementDialog = ref<boolean>(false);
const reportsOnlyAccess = ref<boolean>(false);
const showProductInfoDialog = ref<boolean>(false);
const infoNoteTargetUrl = ref<string | null>(null);
const hideInfoNote = ref<boolean>(false);
const remoteSystemTenant = ref<boolean>(false);
const externalChatTokenCreation = ref<boolean>(false);
const enableCampaigns = ref<boolean>(false);
const isTfaEnabledForTenant = ref<boolean>(false);
const isTfaEnforcedForAllUsers = ref<boolean>(false);
const showTfaConfirmationCodeDialog = ref<boolean>(false);
const tfaCode = ref<string | null>(null);

const passwordChangeTfaCode = ref<string | null>(null);
const showTFAforPasswordChangeDialog = ref<boolean>(false);
const isTFARequiredForPasswordChange = ref<boolean>(false);

const tfaCodeRef = ref();
const passwordChangeTfaCodeRef = ref();
const user = ref<User | null>(userModule.loggedInUser);
const showLoadMoreButton = ref(false);

const aiAssistantTenant = ref<boolean>(false);

onMounted(async () => {
  showMasterDataTab.value =
    (await userModule.isCred('ADMIN')) ||
    (await userModule.isCred('SUPERADMIN'));

  await loadUserPreferredLanguage();
  showSettingsTab.value = await userModule.isGroupAdmin();
  superAdminCred.value = await userModule.isCred('SUPERADMIN');
  messageCenterCred.value = await userModule.isFeatureCred('MESSAGE_CENTER');
  bulkMessageCred.value = await userModule.isFeatureCred('BULK_MESSAGES');
  assessmentCred.value = await userModule.isFeatureCred('ASSESSMENTS');
  showCreateTenantTab.value = superAdminCred.value;

  await loadTenantInfo();

  if (userModule.loggedInUser) {
    await loadInfoNote();
    await loadLanguageOptions();
    await loadTenantMessageInfo();
  }
});

const onPitchYouNavSelected = () => {
  router.push({ name: 'dashboard' });
};

const onRecruitMeNavSelected = () => {
  router.push({ name: 'messagecenter' });
};

const onReportsNavSelected = () => {
  if (superAdminCred.value) {
    router.push({ name: 'reports' });
  } else {
    if (messageCenterStandalone.value) {
      router.push({ name: 'conversationreports' });
    } else {
      router.push({ name: 'reports' });
    }
  }
};

const loadUserPreferredLanguage = async () => {
  let user = userModule.loggedInUser;
  if (user && user.preferredLanguageCode) {
    locale.value = user.preferredLanguageCode;
  }
};

const loadTenantMessageInfo = async () => {
  try {
    if (!reportsOnlyAccess.value || superAdminCred.value) {
      const tenantMessageInfo: TenantMessageInfo =
        await tenantModule.loadTenantMessageInfo();
      renderMessageBtn.value = tenantMessageInfo.renderMessageBtn;
      unreadMessages.value = tenantMessageInfo.unreadMessages;
    }
  } catch (error) {
    console.log(error);
  }
};

const openNewSupportTicketMail = () => {
  window.open('mailto:support@pitchyou.de', '_blank');
};

const openGoogleRatingPage = () => {
  window.open('https://g.page/r/CUvjditF0dlGEBI/review', '_blank');
};

const loadTenantInfo = async () => {
  try {
    tenant.value = tenantModule.tenantInfo || null;
    if (!tenant.value) {
      await tenantModule.loadTenantInfo();
      tenant.value = tenantModule.tenantInfo;
    }

    if (tenant.value) {
      messageCenterStandalone.value = tenant.value
        .messageCenterStandalone as boolean;
      showDefaultHeaderMenu.value = !messageCenterStandalone.value;
      showMessageCenterMenu.value = messageCenterStandalone.value;
      messageCenterFeature.value = tenant.value.messageCenterFeature as boolean;
      reportsOnlyAccess.value = tenant.value.reportsOnlyAccess;
      remoteSystemTenant.value = tenant.value.remoteSystem;
      externalChatTokenCreation.value = tenant.value
        .externalChatTokenCreation as boolean;
      enableCampaigns.value = tenant.value.enableCampaigns;
      isTfaEnabledForTenant.value = tenant.value.tfaEnabled;
      isTfaEnforcedForAllUsers.value = tenant.value.tfaEnforcedForAllUsers;
      aiAssistantTenant.value = tenant.value.aiAssistantTenant as boolean;
      if (superAdminCred.value) {
        selectedTopLevelNav.value = 'pitchyou';
      } else if (reportsOnlyAccess.value) {
        selectedTopLevelNav.value = 'reports';
      } else if (messageCenterStandalone.value) {
        selectedTopLevelNav.value = 'recruitme';
      }
    }
    if (
      superAdminCred.value ||
      (messageCenterFeature.value && messageCenterCred.value)
    ) {
      showNavigationDropdown.value = true;
    }
  } catch (error) {
    console.log(error);
  }
  if (!tenant.value) {
    router.push({ name: 'invalidtenant' });
  }
};

const getTenantInfo = () => {
  return tenant.value ? tenant.value : tenantModule.tenantInfo;
};

const onLogout = (): void => {
  userModule.logoutUser();
  router.push({ name: 'home' });
};

const onChangePassword = async () => {
  try {
    showLoadingIndicator.value = true;
    if (newPassword.value) {
      let user = await userModule.loggedInUser;
      if (validatePassword(newPassword.value)) {
        if (isTfaEnforcedForAllUsers.value || (user && user.tfaEnabled)) {
          if (passwordChangeTfaCodeRef.value != null) {
            const passwordChangeTfaCodeEl: any = passwordChangeTfaCodeRef.value;
            passwordChangeTfaCodeEl.validate();
            if (passwordChangeTfaCodeEl.hasError) {
              return;
            }
          }
        }

        const changePasswordRequest: ChangePasswordRequest = {
          newPassword: newPassword.value,
          tfaCode: passwordChangeTfaCode.value
        };
        await userModule.performChangePassword(changePasswordRequest);
        showSuccessMsgToast(t('message.passwordChangedSuccess') as string);
        newPassword.value = '';
        isShowChPwDialog.value = false;
      }
    }
  } catch (error) {
    console.error(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else if (
      (error as any)?.message &&
      (error as any).message.includes('TFA_ERROR')
    ) {
      showErrorMsgToast(t('message.invalidCodeLbl') as string);
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } finally {
    showLoadingIndicator.value = false;
  }
};

const loadInfoNote = async () => {
  try {
    const infoNote = await userModule.doGetInfoNote();
    if (infoNote && infoNote.targetUrl) {
      infoNoteTargetUrl.value = infoNote.targetUrl;
      showProductInfoDialog.value = true;
    }
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const updateInfoNote = () => {
  try {
    userModule.doUpdateInfoNote();
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const validatePassword = (password: string): boolean => {
  return /^(?=.*[0-9])(?=.*[a-zäüö])(?=.*[A-ZÄÜÖ])(?=.*[-_;#+:,?=*.§!@$%^&(){}[\]]){8,32}/.test(
    password
  );
};

const onChangeNotification = async () => {
  try {
    if (user.value) {
      const updatedUser = await userModule.performNotificationsChange(
        user.value
      );
      userModule.setUser(updatedUser);
    }
  } catch (error) {
    console.error(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const getMediaTypeIconName = (mediaType: string) => {
  switch (mediaType) {
    case 'IMAGE':
      return 'photo';
    case 'VIDEO':
      return 'voice_chat';
    case 'AUDIO':
      return 'record_voice_over';
    case 'DOCUMENT':
      return 'description';
    default:
      break;
  }
};

const loadChatMessages = async () => {
  try {
    showMessagesLoadingSpinner.value = true;
    const request: AllChatMessageRequestDto = {
      page: currentPageNumber.value,
      limit: pageLimit.value,
      searchTerm: '',
      showNewContacts: false,
      unreadMessages: false
    };
    const response = await chatMessageModule.getAllChatMessages(request);
    showMessagesLoadingSpinner.value = false;
    totalPages.value = response.totalPages;
    if (response && response.contacts) {
      response.contacts.forEach(val =>
        messages.value.push(Object.assign({}, val))
      );
      nextPageNumber.value = nextPageNumber.value + 1;
      return response.contacts.length < 15;
    }
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  }
};

const getFormattedDate = (date: Date) => {
  if (date) {
    return new Date(date).toLocaleString();
  }

  return '';
};

const goToInterviewChat = (guid: string) => {
  const paramValues: any = {};
  paramValues.chat = '1';
  router.replace({
    name: 'interviewrecruiter',
    params: { interviewGuid: guid },
    query: paramValues
  });
  //PYS-2715 : Navigate to same page when second time clicked on notification items.
  router.afterEach(() => {
    router.go(0);
  });
};

const getLastMessageSlug = () => {
  if (messages.value && messages.value.length > 0) {
    return messages.value[messages.value.length - 1].slug;
  }
  return '';
};

const messageIconClicked = async () => {
  if (
    messageCenterStandalone.value ||
    superAdminCred.value ||
    (messageCenterFeature.value && messageCenterCred.value)
  ) {
    router.push({ name: 'messagecenter' });
  } else {
    currentPageNumber.value = 0;
    nextPageNumber.value = 0;
    showAllMessages();
  }
};

const showAllMessages = async () => {
  messages.value = [];
  showMessageDialog.value = true;
  await loadChatMessages();
  document.title = t('message.applicationTitle') as string;
};

const onNotification = async (message: any) => {
  const notificationMessage: NotificationMessage = JSON.parse(message);
  if (
    notificationMessage &&
    ('NEW_MESSAGE' == notificationMessage.type ||
      'UPDATE_UNREADS' == notificationMessage.type)
  ) {
    /* const response = await chatMessageModule.getAllChatMessagesCount(); */
    const tenantMessageInfo: TenantMessageInfo =
      await new Promise<TenantMessageInfo>(resolve => {
        setTimeout(() => {
          resolve(tenantModule.loadTenantMessageInfo());
        }, 1000);
      });
    if (tenantMessageInfo) {
      const doPlaySound: boolean =
        unreadMessages.value < tenantMessageInfo.unreadMessages;
      unreadMessages.value = tenantMessageInfo.unreadMessages;
      if (doPlaySound) {
        const audio = new Audio(notificationSound);
        audio.loop = false;
        const playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Automatic playback started!
            })
            .catch(function (error) {
              // Automatic playback failed.
            });
        }
        document.title = t('message.newNotificationsMsg', {
          unreadCount: unreadMessages.value
        }) as string;
      }
      if (unreadMessages.value == 0) {
        document.title = t('message.applicationTitle') as string;
      }
    }

    /*      const doPlaySound: boolean =
        unreadMessages < notificationMessage.unreadMessages;
      unreadMessages = notificationMessage.unreadMessages;
      if (doPlaySound) {
        const audio = new Audio(notificationSound);
        audio.loop = false;
        const playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise
            .then(function() {
              // Automatic playback started!
            })
            .catch(function(error) {
              // Automatic playback failed.
            });
        }
        document.title = $t('message.newNotificationsMsg', {
          unreadCount: unreadMessages
        }) as string;
      } */
  }
};

// Common reusable function to check if the Load More button should be shown
const displayLoadMoreButton = (target: HTMLElement) => {
  // Get the total scrollable height of the container
  const totalScrollableHeight = target.scrollHeight - target.clientHeight;
  // Check if the user has scrolled to the bottom
  return (
    target.scrollTop >= totalScrollableHeight - 1 &&
    currentPageNumber.value + 1 < totalPages.value
  );
};

// Scroll event handler
const onScroll = (event: Event) => {
  const target = event.target as HTMLElement;
  showLoadMoreButton.value = displayLoadMoreButton(target);
};

// Manual check for scroll position after loading more content
const checkScrollPosition = () => {
  const target = document.getElementById('scroll-target-id') as HTMLElement;
  if (target) {
    showLoadMoreButton.value = displayLoadMoreButton(target);
  }
};

// Function to scroll to the newly loaded content after loading more messages
const scrollToNewRecords = () => {
  const target = document.getElementById('scroll-target-id') as HTMLElement;
  if (target) {
    const currentScrollPosition = target.scrollTop;
    const scrollableHeight = target.scrollHeight - target.clientHeight;

    // Move the scroll 5% down from the current scroll position
    const scrollAmount = scrollableHeight * 0.05;

    // Set the new scroll position
    target.scrollTop = currentScrollPosition + scrollAmount;
  }
};

function toolbarName() {
  return toolbarValue.value;
}

watch(
  () => route.meta,
  () => {
    if (route.meta) {
      toolbarValue.value = (route.meta.toolbarName || '') as string;
    }
  }
);

const username = computed(() => {
  return user.value && user.value.firstName + ' ' + user.value.lastName;
});

const showPreferredLanguage = async () => {
  showLoadingIndicator.value = true;
  showPreferredLanguageDialog.value = true;
  let result = await userModule.doGetUserPreferredLanguage();
  if (result && result.preferredLanguageCode) {
    setPreferredLanguage(result.preferredLanguageCode);
  } else {
    setPreferredLanguage(navigator.language.split('-')[0]);
  }
  showLoadingIndicator.value = false;
};
const loadLanguageOptions = async () => {
  try {
    let languageOptionsData: CountriesOptionResponse = {
      countries: [
        {
          label: 'de',
          value: '🇩🇪'
        },
        {
          label: 'en',
          value: '🇬🇧'
        },
        {
          label: 'fr',
          value: '🇫🇷'
        },
        {
          label: 'nl',
          value: '🇳🇱'
        }
      ]
    };
    languageOptionsResponse.value = languageOptionsData;

    if (languageOptionsResponse.value) {
      languageOptionsResponse.value.countries.forEach(cou =>
        languageOptions.value.push({
          label: cou.value + ' ' + t('message.languageValue_' + cou.label),
          value: cou.label
        })
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const setPreferredLanguage = (languageCode: string) => {
  const foundLanguage = languageOptions.value.find(
    o => o.value === languageCode
  );

  if (foundLanguage) {
    preferredLanguage.value = foundLanguage;
  } else {
    const defaultLanguage = languageOptions.value.find(o => o.value === 'de');

    if (defaultLanguage) {
      preferredLanguage.value = defaultLanguage;
    }
  }
};

const updatePreferredLanguage = async () => {
  if (preferredLanguage.value && preferredLanguage.value.value) {
    await userModule.doUpdateUserPreferredLanguage(
      preferredLanguage.value.value
    );
    locale.value = preferredLanguage.value.value;

    const user = userModule.loggedInUser;
    if (user) {
      user.preferredLanguageCode = preferredLanguage.value.value;
      userModule.setUser(user);
    }
  }

  showPreferredLanguageDialog.value = false;
  router.go(0);
};

// Manual button click handler for loading more data
const handleLoadMoreMessages = () => {
  // Simulate the 'done' callback, manually call loadMoreContacts
  loadMoreContacts(0, (stop?: boolean) => {
    if (stop === true) {
      showLoadMoreButton.value = false; // Hide the button if no more data
    } else {
      scrollToNewRecords(); // Scroll to new records after loading
    }
  });
};

const loadMoreContacts = async (
  _index: number,
  done: (stop?: boolean) => void
) => {
  try {
    if (nextPageNumber.value !== 0) {
      currentPageNumber.value += 1;
      if (currentPageNumber.value < totalPages.value) {
        await loadChatMessages();

        // Check the scroll position again to update the "Load More" button (if needed)
        checkScrollPosition();

        // Indicate to q-infinite-scroll that more data is available to load
        done(false); // Continue loading more data
      } else {
        // No more data available, stop loading
        done(true); // Stop infinite scroll
      }
    } else {
      // If nextPageNumber is 0, stop the infinite scroll
      done(true); // Stop loading more data
    }
  } catch (error) {
    console.error('Error loading more contacts:', error);
    // In case of an error, stop the infinite scroll
    done(true); // Stop infinite scroll on error
  }
};

const isPitchYouAccessible = () => {
  if (superAdminCred.value) {
    return true;
  } else if (reportsOnlyAccess.value) {
    return false;
  } else if (messageCenterStandalone.value) {
    return false;
  } else {
    return true;
  }
};

const isRecruitMeAccessible = () => {
  if (superAdminCred.value) {
    return true;
  } else if (reportsOnlyAccess.value) {
    return false;
  } else if (messageCenterStandalone.value) {
    return true;
  } else if (messageCenterFeature.value && messageCenterCred.value) {
    return true;
  } else {
    return false;
  }
};

function showReportsTabs() {
  if (selectedTopLevelNav.value === 'reports') {
    // if (superAdminCred.value) {
    //   return true;
    // } else if (remoteSystemTenant.value && messageCenterStandalone.value) {
    //   return true;
    // } else if (reportsOnlyAccess.value && !externalChatTokenCreation.value) {
    //   return false;
    // } else if (messageCenterStandalone.value) {
    //   return false;
    // }
    // return (
    //   (messageCenterFeature.value && messageCenterCred.value) ||
    //   externalChatTokenCreation
    // );
    console.log(
      'showReportsTabs:' +
        (showRecruiteMeReportsTab() || showAIAssistantReportsTab())
    );
    return showRecruiteMeReportsTab() || showAIAssistantReportsTab();
  } else {
    return false;
  }
}

function showRecruiteMeReportsTab() {
  if (superAdminCred.value) {
    return true;
  } else if (remoteSystemTenant.value && messageCenterStandalone.value) {
    return true;
  } else if (reportsOnlyAccess.value && !externalChatTokenCreation.value) {
    return false;
  } else if (messageCenterStandalone.value) {
    return false;
  }
  return (
    (messageCenterFeature.value && messageCenterCred.value) ||
    externalChatTokenCreation.value
  );
}

function showAIAssistantReportsTab() {
  if (superAdminCred.value || aiAssistantTenant.value) {
    return true;
  }
  return false;
}

const onChangeTFA = async () => {
  try {
    if (user.value) {
      showLoadingIndicator.value = true;
      if (user.value.tfaEnabled) {
        user.value.sendTfaConfirmationCode = true;
        user.value.tfaEnabled = false;
        await userModule.updateUserTfa(user.value);
        showSuccessMsgToast(
          t('message.tfaCodeSentByEmailMsg', {
            1: user.value ? user.value.username : username.value
          }) as string
        );
        showTfaConfirmationCodeDialog.value = true;
      } else {
        await userModule.updateUserTfa(user.value);
        userModule.setUser(user.value);
      }
    }
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } finally {
    showLoadingIndicator.value = false;
  }
};

const enableTfa = async () => {
  try {
    if (user.value) {
      const tfaCodeRefValue: any = tfaCodeRef.value;
      tfaCodeRefValue.validate();
      if (tfaCodeRefValue.hasError) {
        return;
      }
      showLoadingIndicator.value = true;
      user.value.sendTfaConfirmationCode = false;
      user.value.tfaEnabled = true;
      user.value.tfaCode = tfaCode.value as string;
      await userModule.updateUserTfa(user.value);
      tfaCode.value = null;
      user.value.tfaCode = undefined;
      userModule.setUser(user.value);
      showTfaConfirmationCodeDialog.value = false;
      showSuccessMsgToast(t('message.tfaEnabledSuccessMsg') as string);
    }
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else if (
      (error as any)?.message &&
      (error as any).message.includes('TFA_CODE_ERROR')
    ) {
      showErrorMsgToast(t('message.invalidCodeLbl') as string);
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } finally {
    showLoadingIndicator.value = false;
  }
};

const onCloseTfaConfirmationCodeDialog = async () => {
  if (user.value) {
    user.value.sendTfaConfirmationCode = false;
    user.value.tfaEnabled = false;
    tfaCode.value = null;
    showTfaConfirmationCodeDialog.value = false;
  }
};

const onClickChangePassword = async () => {
  let user = await userModule.loggedInUser;
  if (isTfaEnforcedForAllUsers.value || (user && user.tfaEnabled)) {
    //await sendTFACode();
    passwordChangeTfaCode.value = null;
    isTFARequiredForPasswordChange.value = true;
  }
  newPassword.value = '';
  showTFAforPasswordChangeDialog.value = false;
  isShowChPwDialog.value = true;
};

const sendTFACodeForPasswordChange = async () => {
  if (newPassword.value) {
    if (validatePassword(newPassword.value)) {
      await sendTFACode();
      showTFAforPasswordChangeDialog.value = true;
    }
  }
};

const verifyTFACodeForPasswordChange = async () => {
  try {
    const passwordChangeTfaCodeRefValue: any = passwordChangeTfaCodeRef.value;
    passwordChangeTfaCodeRefValue.validate();
    if (passwordChangeTfaCodeRefValue.hasError) {
      return;
    }
    showLoadingIndicator.value = true;
    const response = await userModule.verifyTFACode(
      passwordChangeTfaCode.value as string
    );
    if (response.validCode) {
      await onChangePassword();
    } else {
      showErrorMsgToast(t('message.invalidCodeLbl') as string);
    }
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } finally {
    showLoadingIndicator.value = false;
  }
};

const sendTFACode = async () => {
  try {
    showLoadingIndicator.value = false;
    await userModule.sendTFACode();
    showSuccessMsgToast(
      t('message.tfaCodeSentByEmailMsg', {
        1: user.value ? user.value.username : username.value
      }) as string
    );
  } catch (error) {
    console.log(error);
    if (
      (error as any)?.message &&
      (error as any).message.includes('TOKEN_ERROR')
    ) {
      router.push({ name: 'home' });
    } else {
      showErrorMsgToast(t('message.failedProcessMsg') as string);
    }
  } finally {
    showLoadingIndicator.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_infinite_scroll = _resolveComponent("q-infinite-scroll")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_auth_media = _resolveDirective("auth-media")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "hhh lpr fff",
    class: "shadow-3"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, { elevated: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_q_tabs, {
                            "no-caps": "",
                            "inline-label": "",
                            dense: "",
                            "switch-indicator": "",
                            align: "left",
                            class: "text-white menu-tabs",
                            modelValue: selectedTopLevelNav.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTopLevelNav).value = $event)),
                            "active-bg-color": "primary"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createVNode(_component_q_tab, {
                                onClick: onPitchYouNavSelected,
                                name: "pitchyou",
                                label: "ChatAgent"
                              }, null, 512), [
                                [_vShow, isPitchYouAccessible()]
                              ]),
                              _withDirectives(_createVNode(_component_q_tab, {
                                onClick: onRecruitMeNavSelected,
                                name: "recruitme",
                                label: "RecruitMe"
                              }, null, 512), [
                                [_vShow, isRecruitMeAccessible()]
                              ]),
                              _createVNode(_component_q_tab, {
                                onClick: onReportsNavSelected,
                                name: "reports",
                                label: "Reports"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(TenantInfo, {
                    tenant: getTenantInfo()
                  }, null, 8, ["tenant"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (user.value)
                      ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                          key: 0,
                          flat: "",
                          unelevated: "",
                          "no-caps": "",
                          class: "text-subtitle1"
                        }, {
                          label: _withCtx(() => [
                            (_unref($q).platform.is.mobile)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createVNode(_component_q_icon, { name: "person" })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(username.value), 1))
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_q_list, null, {
                              default: _withCtx(() => [
                                (superAdminCred.value)
                                  ? (_openBlock(), _createBlock(_component_q_item, {
                                      key: 0,
                                      clickable: "",
                                      "no-caps": "",
                                      to: { name: 'superadminconfig' }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_icon, { name: "admin_panel_settings" })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.superAdminConfigLbl')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (showMasterDataTab.value)
                                  ? (_openBlock(), _createBlock(_component_q_item, {
                                      key: 1,
                                      clickable: "",
                                      "no-caps": "",
                                      to: { name: 'masterdata' }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_icon, { name: "business" })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.masterDataLbl')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (showSettingsTab.value)
                                  ? (_openBlock(), _createBlock(_component_q_item, {
                                      key: 2,
                                      clickable: "",
                                      "no-caps": "",
                                      to: { name: 'tenant_admin' }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_icon, { name: "group" })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.tenant_adminLbl')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_q_item, {
                                  clickable: "",
                                  "no-caps": "",
                                  onClick: showPreferredLanguage
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "language" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.preferredLanguageLbl')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _withDirectives(_createVNode(_component_q_item, {
                                  clickable: "",
                                  "no-caps": "",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showTagsManagementDialog.value = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "local_offer" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.manageTagsLbl')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, !reportsOnlyAccess.value || superAdminCred.value]
                                ]),
                                (isTfaEnabledForTenant.value && !isTfaEnforcedForAllUsers.value)
                                  ? (_openBlock(), _createBlock(_component_q_item, { key: 3 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_section, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.enableTFA')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_q_item_section, { side: "" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_toggle, {
                                              modelValue: user.value.tfaEnabled,
                                              "onUpdate:modelValue": [
                                                _cache[2] || (_cache[2] = ($event: any) => ((user.value.tfaEnabled) = $event)),
                                                onChangeTFA
                                              ],
                                              "keep-color": "",
                                              color: "primary",
                                              size: "lg"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (
                        showDefaultHeaderMenu.value &&
                        (!reportsOnlyAccess.value || superAdminCred.value)
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                      _createVNode(_component_q_separator),
                                      _createVNode(_component_q_item_label, { header: "" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('message.emailNotificationsLbl')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('message.notifyNewInterviewsLbl')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_item_section, { side: "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_toggle, {
                                                modelValue: user.value.notifyNewInterviews,
                                                "onUpdate:modelValue": [
                                                  _cache[3] || (_cache[3] = ($event: any) => ((user.value.notifyNewInterviews) = $event)),
                                                  onChangeNotification
                                                ],
                                                "keep-color": "",
                                                color: "primary",
                                                size: "lg"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('message.notifyDailySummaryLbl')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_item_section, {
                                            side: "",
                                            top: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_toggle, {
                                                modelValue: user.value.notifyDailySummary,
                                                "onUpdate:modelValue": [
                                                  _cache[4] || (_cache[4] = ($event: any) => ((user.value.notifyDailySummary) = $event)),
                                                  onChangeNotification
                                                ],
                                                "keep-color": "",
                                                color: "primary",
                                                size: "lg"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.$t('message.notifyUnreadChatMessagesLbl')), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_item_section, {
                                            side: "",
                                            top: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_toggle, {
                                                modelValue: user.value.notifyUnreadChatMessages,
                                                "onUpdate:modelValue": [
                                                  _cache[5] || (_cache[5] = ($event: any) => ((user.value.notifyUnreadChatMessages) = $event)),
                                                  onChangeNotification
                                                ],
                                                "keep-color": "",
                                                color: "primary",
                                                size: "lg"
                                              }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_q_separator),
                                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                  clickable: "",
                                  "no-caps": "",
                                  onClick: openGoogleRatingPage
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "fab fa-google" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.googleRatingLbl')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('message.googleRatingTooltip')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })), [
                                  [_directive_close_popup]
                                ]),
                                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                  clickable: "",
                                  onClick: onClickChangePassword
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "security" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.changePwLbl')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })), [
                                  [_directive_close_popup]
                                ]),
                                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                  clickable: "",
                                  onClick: onLogout
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "eject" })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_item_label, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.logoutLbl')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })), [
                                  [_directive_close_popup]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      onClick: openNewSupportTicketMail,
                      icon: "contact_support",
                      dense: "",
                      flat: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.openNewSupportTicketMailLbl')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  (renderMessageBtn.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          icon: "mail",
                          onClick: messageIconClicked
                        }, {
                          default: _withCtx(() => [
                            (unreadMessages.value > 0)
                              ? (_openBlock(), _createBlock(_component_q_badge, {
                                  key: 0,
                                  color: "secondary",
                                  floating: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(unreadMessages.value), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(ServerNotification, { onOnNotification: onNotification })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (isPitchYouAccessible() && selectedTopLevelNav.value == 'pitchyou')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_q_tabs, {
                  "no-caps": "",
                  "inline-label": "",
                  dense: "",
                  "narrow-indicator": "",
                  align: "center",
                  modelValue: toolbarName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((toolbarName) = $event)),
                  "active-bg-color": "grey-5",
                  class: "menu-tabs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_route_tab, {
                      name: "dashboard",
                      icon: "dashboard",
                      label: _ctx.$t('message.dashboardLbl'),
                      to: { name: 'dashboard' },
                      class: "q-ml-xl"
                    }, null, 8, ["label"]),
                    _createVNode(_component_q_route_tab, {
                      name: "managejobs",
                      icon: "business_center",
                      label: _ctx.$t('message.manageJobsLbl'),
                      to: { name: 'managejobs' }
                    }, null, 8, ["label"]),
                    _createVNode(_component_q_route_tab, {
                      name: "applicants",
                      icon: "person_pin",
                      label: _ctx.$t('message.applicantSearchLbl'),
                      to: { name: 'applicants' }
                    }, null, 8, ["label"]),
                    _withDirectives(_createVNode(_component_q_route_tab, {
                      name: "pitchyouquestionnaire",
                      icon: "format_list_numbered",
                      label: _ctx.$t('message.questionnaireMenuTitle'),
                      to: { name: 'recruiterquestionnaire' }
                    }, null, 8, ["label"]), [
                      [_vShow, enableCampaigns.value]
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (isRecruitMeAccessible() && selectedTopLevelNav.value == 'recruitme')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_q_tabs, {
                  "no-caps": "",
                  "inline-label": "",
                  dense: "",
                  "narrow-indicator": "",
                  align: "center",
                  modelValue: toolbarName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((toolbarName) = $event)),
                  "active-bg-color": "grey-5",
                  class: "menu-tabs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_route_tab, {
                      name: "messagecenter",
                      icon: "question_answer",
                      label: _ctx.$t('message.messageCenterTitle'),
                      to: { name: 'messagecenter' },
                      class: "q-ml-xl"
                    }, null, 8, ["label"]),
                    (bulkMessageCred.value || superAdminCred.value)
                      ? (_openBlock(), _createBlock(_component_q_route_tab, {
                          key: 0,
                          name: "bulkmessages",
                          icon: "campaign",
                          label: _ctx.$t('message.bulkMessagesHeader'),
                          to: { name: 'bulkmessages' }
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (assessmentCred.value || superAdminCred.value)
                      ? (_openBlock(), _createBlock(_component_q_route_tab, {
                          key: 1,
                          name: "assessments",
                          icon: "psychology",
                          label: _ctx.$t('message.assessmentRunsHeader'),
                          to: { name: 'assessmentruns' }
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (assessmentCred.value || superAdminCred.value)
                      ? (_openBlock(), _createBlock(_component_q_route_tab, {
                          key: 2,
                          name: "questionnaire",
                          icon: "format_list_numbered",
                          label: _ctx.$t('message.questionnaireMenuTitle'),
                          to: { name: 'questionnaire' },
                          class: "q-mr-md"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_q_route_tab, {
                      name: "contactsimport",
                      icon: "upload_file",
                      label: _ctx.$t('message.contactsImportHeader'),
                      to: { name: 'contactsimport' },
                      class: "q-mr-xl"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createVNode(_component_q_tabs, {
              "no-caps": "",
              "inline-label": "",
              dense: "",
              "narrow-indicator": "",
              align: "center",
              modelValue: toolbarValue.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((toolbarValue).value = $event)),
              "active-bg-color": "grey-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_route_tab, {
                  name: "reports",
                  icon: "insights",
                  label: "ChatAgent",
                  to: { name: 'reports' }
                }),
                _withDirectives(_createVNode(_component_q_route_tab, {
                  name: "conversationreports",
                  icon: "bar_chart",
                  label: "RecruitMe",
                  to: { name: 'conversationreports' }
                }, null, 512), [
                  [_vShow, showRecruiteMeReportsTab()]
                ]),
                _withDirectives(_createVNode(_component_q_route_tab, {
                  name: "aireports",
                  icon: "assistant",
                  label: "Conversational AI",
                  to: { name: 'aireports' },
                  style: {"margin-right":"10%"}
                }, null, 512), [
                  [_vShow, showAIAssistantReportsTab()]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 512), [
            [_vShow, showReportsTabs()]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          (showMessageDialog.value)
            ? (_openBlock(), _createBlock(_component_q_dialog, {
                key: 0,
                modelValue: showMessageDialog.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showMessageDialog).value = $event)),
                position: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_infinite_scroll, {
                        onLoad: loadMoreContacts,
                        offset: 500,
                        "scroll-target": "#scroll-target-id"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card_section, { class: "q-pa-xs" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, {
                                bordered: "",
                                separator: "",
                                class: "rounded-borders",
                                style: {"max-width":"400px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, {
                                    header: "",
                                    class: "q-pa-xs bg-secondary"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_16, [
                                        (showMessagesLoadingSpinner.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              _createVNode(_component_q_spinner)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_q_icon, {
                                          name: "mail",
                                          size: "sm"
                                        }),
                                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('message.messageCenterLbl')), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_q_separator),
                                  _createElementVNode("div", {
                                    id: "scroll-target-id",
                                    onScroll: onScroll,
                                    style: {"max-height":"600px","min-height":"600px","overflow":"auto","min-width":"400px"}
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                                      return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                        clickable: "",
                                        key: message.slug,
                                        onClick: ($event: any) => (goToInterviewChat(message.guid))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, { avatar: "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_avatar, null, {
                                                default: _withCtx(() => [
                                                  (message.avatarUri)
                                                    ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_19, null, 512)), [
                                                        [_directive_auth_media, message.avatarUri]
                                                      ])
                                                    : (_openBlock(), _createElementBlock("img", _hoisted_20))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_q_item_section, {
                                            class: _normalizeClass(
                        !message.read && !message.sent ? 'text-weight-bold' : ''
                      )
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_item_label, { lines: "1" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(message.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_q_item_label, {
                                                caption: "",
                                                lines: "2"
                                              }, {
                                                default: _withCtx(() => [
                                                  (message.unreadMessages > 0)
                                                    ? (_openBlock(), _createBlock(_component_q_badge, {
                                                        key: 0,
                                                        color: "accent"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(message.unreadMessages), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : _createCommentVNode("", true),
                                                  ('TEXT' == message.mediaType)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 1,
                                                        class: _normalizeClass(
                            !message.read && !message.sent
                              ? 'text-weight-bold'
                              : ''
                          )
                                                      }, _toDisplayString(message.text), 3))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                        _createVNode(_component_q_icon, {
                                                          name: getMediaTypeIconName(message.mediaType)
                                                        }, null, 8, ["name"])
                                                      ]))
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"]),
                                          _createVNode(_component_q_item_section, {
                                            side: "",
                                            top: "",
                                            class: _normalizeClass(
                        !message.read && !message.sent ? 'text-weight-bold' : ''
                      )
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(getFormattedDate(message.sentAt)), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["class"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])), [
                                        [_directive_ripple]
                                      ])
                                    }), 128))
                                  ], 32)
                                ]),
                                _: 1
                              }),
                              (showLoadMoreButton.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_q_btn, {
                                      rounded: "",
                                      "no-caps": "",
                                      icon: "chat",
                                      label: _ctx.$t('message.loadMoreLbl'),
                                      onClick: handleLoadMoreMessages
                                    }, null, 8, ["label"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_dialog, {
            modelValue: isShowChPwDialog.value,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isShowChPwDialog).value = $event)),
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('message.passwordChangeHeader')), 1),
                      _createVNode(_component_q_space),
                      _withDirectives(_createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_input, {
                        filled: "",
                        type: isHidePassword.value ? 'password' : 'text',
                        modelValue: newPassword.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newPassword).value = $event)),
                        disable: showTFAforPasswordChangeDialog.value,
                        autofocus: "",
                        color: "primary",
                        rules: [
                val =>
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&äÄöÖüÜ])[A-Za-z\d$@$!%*?&äÄöÖüÜ]{8,}/.test(
                    val
                  ) || _ctx.$t('message.safePasswordRuleLbl')
              ]
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: isHidePassword.value ? 'visibility_off' : 'visibility',
                            class: "cursor-pointer",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (isHidePassword.value = !isHidePassword.value))
                          }, null, 8, ["name"])
                        ]),
                        _: 1
                      }, 8, ["type", "modelValue", "disable", "rules"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('message.tfaForPasswordChangeLbl')), 1),
                      _createVNode(_component_q_input, {
                        filled: "",
                        clearable: "",
                        color: "primary",
                        ref_key: "passwordChangeTfaCodeRef",
                        ref: passwordChangeTfaCodeRef,
                        modelValue: passwordChangeTfaCode.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((passwordChangeTfaCode).value = $event)),
                        label: _ctx.$t('message.tfaCodeLbl'),
                        autofocus: "",
                        "lazy-rules": "",
                        rules: [
                val =>
                  (val && val.length == 6) ||
                  _ctx.$t('message.tfaReqMsg', {
                    1: user.value ? user.value.username : username.value
                  })
              ]
                      }, null, 8, ["modelValue", "label", "rules"])
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, showTFAforPasswordChangeDialog.value]
                  ]),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_actions, {
                    align: "right",
                    class: "text-primary"
                  }, {
                    default: _withCtx(() => [
                      (
                isTFARequiredForPasswordChange.value &&
                !showTFAforPasswordChangeDialog.value
              )
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            label: _ctx.$t('message.nextLbl'),
                            "no-caps": "",
                            color: "primary",
                            onClick: sendTFACodeForPasswordChange
                          }, null, 8, ["label"]))
                        : (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            label: _ctx.$t('message.saveLbl'),
                            color: "primary",
                            onClick: onChangePassword
                          }, null, 8, ["label"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: showPreferredLanguageDialog.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showPreferredLanguageDialog).value = $event)),
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"350px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.setPreferredLanguageLbl')), 1),
                      _createVNode(_component_q_space),
                      _withDirectives(_createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_q_select, {
                              filled: "",
                              dense: "",
                              "map-options": "",
                              class: "col-5",
                              options: languageOptions.value,
                              modelValue: preferredLanguage.value,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((preferredLanguage).value = $event)),
                              color: "primary",
                              label: _ctx.$t('message.preferredLanguageLbl')
                            }, null, 8, ["options", "modelValue", "label"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_q_btn, {
                              color: "primary",
                              onClick: updatePreferredLanguage,
                              icon: "save",
                              label: _ctx.$t('message.updateContactLbl')
                            }, null, 8, ["label"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: showTagsManagementDialog.value,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((showTagsManagementDialog).value = $event)),
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(TagsManagement, { loadTags: true })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: showProductInfoDialog.value,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((showProductInfoDialog).value = $event)),
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"80%","min-height":"82vh"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _createElementVNode("iframe", {
                      src: infoNoteTargetUrl.value,
                      style: {"min-width":"100%","height":"78vh"}
                    }, null, 8, _hoisted_30),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_q_checkbox, {
                        modelValue: hideInfoNote.value,
                        "onUpdate:modelValue": [
                          _cache[17] || (_cache[17] = ($event: any) => ((hideInfoNote).value = $event)),
                          updateInfoNote
                        ]
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('message.hideInfoNoteLbl')), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: showTfaConfirmationCodeDialog.value,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((showTfaConfirmationCodeDialog).value = $event)),
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"min-width":"40vw","max-width":"80vw"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, { class: "row items-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('message.enableTFA')), 1),
                      _createVNode(_component_q_space),
                      _createVNode(_component_q_btn, {
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: "",
                        onClick: onCloseTfaConfirmationCodeDialog
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_section, {
                    style: {"max-height":"40vh"},
                    class: "scroll"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_input, {
                        filled: "",
                        clearable: "",
                        color: "primary",
                        ref_key: "tfaCodeRef",
                        ref: tfaCodeRef,
                        modelValue: tfaCode.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((tfaCode).value = $event)),
                        label: _ctx.$t('message.tfaCodeLbl'),
                        autofocus: "",
                        "lazy-rules": "",
                        rules: [
                val =>
                  (val && val.length == 6) ||
                  _ctx.$t('message.tfaReqMsg', {
                    1: user.value ? user.value.username : username.value
                  })
              ]
                      }, null, 8, ["modelValue", "label", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_separator),
                  _createVNode(_component_q_card_actions, { align: "right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, {
                        icon: "save",
                        label: _ctx.$t('message.saveLbl'),
                        color: "primary",
                        onClick: enableTfa,
                        "no-caps": "",
                        dense: ""
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(LoadingIndicator, { showLoading: showLoadingIndicator.value }, null, 8, ["showLoading"])
        ]),
        _: 1
      }),
      _createVNode(BrandFooter)
    ]),
    _: 1
  }))
}
}

})